export const getUtmTagsToMetadata = () => {
    const utmTags = [`utm_medium`, `utm_campaign`, `utm_source`];
    const urlParams = new URLSearchParams(window.location.search);

    const metadata: Record<string, string> = {};
    utmTags.forEach((utmTag) => {
        const utmValue = urlParams.get(utmTag);
        if (utmValue) {
            metadata[utmTag] = utmValue;
        }
    });

    return metadata;
};
